<template>
  <div
    v-click-outside="hideConversationList"
    :class="{opened: conversationListOpened}"
    class="conversations-box">
    <b-row
      v-if="showSearchForm"
      class="search-folders">
      <b-button-group>
        <b-button
          :class="{active: folder === 'open'}"
          :disabled="folder === 'open'"
          class="btn btn-main"
          @click="selectMessageFolder('open')">Open</b-button>
        <b-button
          :class="{active: folder === 'done'}"
          :disabled="folder === 'done'"
          class="btn btn-main"
          @click="selectMessageFolder('done')">Done</b-button>
        <b-button
          :class="{active: folder === 'spam'}"
          :disabled="folder === 'spam'"
          class="btn btn-main"
          @click="selectMessageFolder('spam')">Spam</b-button>
      </b-button-group>
    </b-row>
    <!--<b-row
      v-if="(folder !== 'spam') && !showSearchForm"
      class="assignment-box">
      <b-col
        :class="{active : assignmentFolder === 'all'}"
        cols="4"
        class="assignment-option"
        @click="changeAssignmentFolder('all')">
        <h4>{{ statistics[folder].all }}</h4>
        <p>All</p>
        <span class="has-unread"><span
          v-if="statistics.open.all_unread && (folder === 'open')"
          class="unread-count-dot">{{ statistics.open.all_unread }}</span></span>
      </b-col>
      <b-col
        :class="{active : assignmentFolder === 'unassigned'}"
        cols="4"
        class="assignment-option"
        @click="changeAssignmentFolder('unassigned')">
        <h4>{{ statistics[folder].unassigned }}</h4>
        <p>Unassigned</p>
        <span class="has-unread"><span
          v-if="statistics.open.unassigned_unread && (folder === 'open')"
          class="unread-count-dot">{{ statistics.open.unassigned_unread }}</span></span>
      </b-col>
      <b-col
        :class="{active : assignmentFolder === 'user_assigned'}"
        cols="4"
        class="assignment-option"
        @click="changeAssignmentFolder('user_assigned')">
        <h4>{{ statistics[folder].user_assigned[userId] || 0 }}</h4>
        <p>You</p>
        <span class="has-unread"><span
          v-if="statistics.open.user_unread[userId] && (folder === 'open')"
          class="unread-count-dot">{{ statistics.open.user_unread[userId] }}</span></span>
      </b-col>
    </b-row>-->
    <ScrollArea
      ref="conversationScrollbar"
      :class="{'height-md': showSearchForm}"
      class="inbox-chat-container"
      @bottom="handleBottomScroll">
      <div class="inbox-chat-list">
        <template v-if="!forceSpinner && (conversationsLoad.loaded || (!conversationsLoad.loaded && (page !== 1)))">
          <div
            v-for="conversation in conversations"
            :key="conversation.id"
          >
            <Transition>
              <div
                v-if="!conversation.hide"
                :class="{
                  'active-chat' : (currentConversation && (currentConversation.id === conversation.id)),
                  'not-seen': conversationIsUnread(conversation),
                  'changed-activity': !!conversation.changed_activity,
                }"
                class="chat-details"
                @click="changeCurrentConversation(conversation)">
                <!-- TEMP conversation is slightly different -->
                <template
                  v-if="conversation.id.startsWith('TEMP-conversation')"
                  class="flex" >
                  <SBAvatar
                    class="no-shrink avatar"
                    size="l-button"
                    :show-data="true"
                    :character-count="1"
                    :person="{name: 'Unassigned'}"
                    :hide-avatar-image="true" />
                  <div class="data">
                    <div
                      class="title new-conversation" >
                      <h5>
                        <span>New: </span>
                        {{ conversation.name ? conversation.name : conversation.phone | phoneFormat }}
                      </h5>
                      <!-- <span class="chat-date">
                        {{ newestDate(conversation) | dateDiff }}
                      </span> -->
                    </div>
                    <p class="last-message">
                      Start a conversation
                    </p>
                    <span
                      v-if="!conversation.changed_activity"
                      :class="{ hide: numberMembers && activeConversation && ((numberMembers[activeConversation.business_id] && numberMembers[activeConversation.business_id].length === 1) || (numberMembers[activeConversation.businessId] && numberMembers[activeConversation.businessId].length === 1)) }"
                      class="conversation-footer assignee-name">{{ findAssigneeName(conversation.user_id) }}</span>
                    <span class="cancel-conversation">
                      <SBIcon
                        :id="`cancel-conversation-${conversation.id}`"
                        :class="{ 'top-10': numberMembers && activeConversation && ((numberMembers[activeConversation.business_id] && numberMembers[activeConversation.business_id].length === 1) || (numberMembers[activeConversation.businessId] && numberMembers[activeConversation.businessId].length === 1)) }"
                        :icon="SBIconList.CLOSE_THIN"
                        :color="conversation.id === activeConversation.id ? '#C7E0F5' : '#54626C'"
                        :hover-icon-color="conversation.id === activeConversation.id ? SBColors.white : SBColors.blackPrimary"
                        :background-color="conversation.id === activeConversation.id ? '#0067c3' : '#dde6e9'"
                        :size="6"
                        :hover-size="16"
                        :border-radius="50"
                        :pointer="true"
                        @click.native.stop="cancelConversation(conversation)" />
                    </span>
                    <b-popover
                      :target="`cancel-conversation-${conversation.id}`"
                      triggers="hover"
                      boundary="window"
                      placement="bottom"
                      custom-class="basic-popover" >
                      Cancel
                    </b-popover>
                  </div>
                </template>
                <!-- <div class="chat-user">
                  <img
                    :src="`/static/img/avatars/user-chat-icon-${conversation.contact.avatar}.svg`"
                    class="avatar img-responsive rounded-circle">
                  <div class="chat-user-info">
                    <h5>
                      {{ conversation.contact.name ? conversation.contact.name : conversation.contact.phone }}
                      <span class="chat-date">
                        {{ newestDate(conversation) | dateDiff }}
                      </span>
                    </h5>
                    <p>
                      <span v-if="['outbound', 'outbound-api'].includes(conversation.message_direction)">You: </span>
                      <span v-if="['bot', 'outbound-reply'].includes(conversation.message_direction)">Bot: </span>
                      <MessageContent :content="conversation.last_message"/>
                    </p>
                  </div>
                </div>
                <span
                  v-if="!conversation.changed_activity"
                  class="assignee-name">{{ findAssigneeName(conversation.user_id) }}</span>
                <span
                  v-else
                  class="changed-activity-message">{{ conversation.changed_activity.text }}</span> -->
                <!-- <img
                  v-if="!conversation.id.startsWith('TEMP-conversation') && conversation.contact && conversation.contact.avatar"
                  :src="`/static/img/avatars/user-chat-icon-${conversation.contact.avatar}.svg`"
                  class="avatar img-responsive rounded-circle"> -->
                <span
                  v-if="!conversation.id.startsWith('TEMP-conversation')"
                  class="no-shrink avatar">
                  <SBAvatar
                    size="l-button"
                    :show-data="true"
                    :person="conversation.contact"
                    :character-count="1"
                    :show-client="true"
                    :hide-avatar-image="true" />
                  <!-- BLOCKED MARKER -->
                  <!-- <SBIcon
                    v-if="conversation.blocked"
                    class="blocked-conversation"
                    :icon="SBIconList.BLOCK"
                    :color="SBColors.redPrimary"
                    :background-color="SBColors.white"
                    :size="12"
                    :hover-size="16"
                    :border-radius="50"
                    :pointer="true" /> -->
                  <!-- BLOCKED MARKER END-->
                </span>
                <div
                  v-if="!conversation.id.startsWith('TEMP-conversation')"
                  class="data">
                  <div class="title">
                    <h5 class="ellipsis">
                      {{ conversation.contact.name ? conversation.contact.name : conversation.contact.phone | phoneFormat }}
                    </h5>
                    <span class="chat-date flex flex-align-center no-shrink">
                      <SBIcon
                        v-if="conversation.live_inbox === false || (conversation.broadcast && !conversation.broadcast.live_inbox)"
                        :id="`broadcast-info-${conversation.id}`"
                        class="mr-1"
                        style="margin-top: -2px;"
                        :icon="SBIconList.INFORMATION"
                        :color="currentConversation && (currentConversation.id === conversation.id) ? '#b9dcff' : '#7dbcfa'"
                        :size="11" />
                      {{ newestDate(conversation) | dateDiff }}
                    </span>
                    <b-popover
                      v-if="conversation.live_inbox === false || (conversation.broadcast && !conversation.broadcast.live_inbox)"
                      :target="`broadcast-info-${conversation.id}`"
                      triggers="hover"
                      boundary="window"
                      placement="top" >
                      <h1>Why is this conversation marked with a blue badge?</h1>
                      <p>To prevent disruption to ongoing conversations, the last message received in this conversation kept the conversation at its current position in the conversation list.</p>
                    </b-popover>
                  </div>
                  <div class="last-message flex-align-center">
                    <p class="greedy ellipsis w-100 flex flex-align-center">
                      <!-- <span v-if="['outbound', 'outbound-api'].includes(conversation.message_direction)">You: </span>
                      <span v-if="['bot', 'outbound-reply'].includes(conversation.message_direction)">Bot: </span>
                      <template v-if="['broadcast'].includes(conversation.message_direction) && (typeof conversation.live_inbox) ">
                        <SBIcon
                          class="mri-1"
                          :icon="SBIconList.BROADCAST"
                          :color="currentConversation && (currentConversation.id === conversation.id) ? SBColors.white : SBColors.blackPrimary"
                          :size="14" />
                        <DotSeparator
                          :color="currentConversation && (currentConversation.id === conversation.id) ? SBColors.white : SBColors.blackPrimary"
                          :size="3"
                          class="ml-1 mr-1" />
                      </template> -->
                      <img
                        v-if="conversation.direction && conversation.direction === 'outbound' && conversation.sender_icon && Number(conversation.sender_icon) && getMemberAvatar(conversation).avatar"
                        :src="getMemberAvatar(conversation).avatar"
                        class="avatar"
                        :alt="conversation.sender" >
                      <SBAvatar
                        v-else-if="conversation.direction && conversation.direction === 'outbound' && conversation.agent"
                        class="no-shrink avatar"
                        size="conversation-avatar"
                        :show-data="true"
                        :character-count="1"
                        :gradient1="(currentConversation && (currentConversation.id === conversation.id)) ? 'white' : 'black'"
                        :gradient2="(currentConversation && (currentConversation.id === conversation.id)) ? 'white' : 'black'"
                        :text-color="(currentConversation && (currentConversation.id === conversation.id)) ? SBColors.blackPrimary : SBColors.white"
                        :person="{name: conversation.sender}"
                        :show-client="true"
                        :hide-avatar-image="true" />
                      <!-- <span
                        v-else-if="conversation.sender_icon && conversation.sender_icon.light && conversation.sender_icon.dark"
                        class="sender-icon"
                        :style="{ 'background-image': `url(${ (currentConversation && (currentConversation.id === conversation.id)) ? conversation.sender_icon.light : conversation.sender_icon.dark })` }" /> -->
                      <img
                        v-else-if="conversation.direction && conversation.direction === 'outbound' && conversation.sender_icon && conversation.sender_icon.light && conversation.sender_icon.dark"
                        class="sender-icon"
                        :src="(currentConversation && (currentConversation.id === conversation.id)) ? conversation.sender_icon.light : conversation.sender_icon.dark" >
                      <span v-else-if="conversation.direction && conversation.direction === 'outbound'">You</span>
                      <DotSeparator
                        v-if="conversation.direction && conversation.direction === 'outbound'"
                        :color="currentConversation && (currentConversation.id === conversation.id) ? SBColors.white : SBColors.blackUltralight"
                        :size="3"
                        style="margin-left: 5px; margin-right: 5px;" />
                      <MessageContent
                        class="ellipsis"
                        :content="conversation.last_message"
                        for-conversation
                        :media="conversation.last_message_media"/>
                    </p>
                    <span
                      v-if="showTheUnseenMarker(conversation) || conversationIsUnread(conversation)"
                      class="counter ml-2 flex center-all">{{ (conversation.message_unseen_count ? conversation.message_unseen_count : '') | ninePlus }}</span>
                  </div>
                  <span
                    v-if="conversation.blocked || !conversation.contact.has_messaging_consent"
                    class="conversation-footer activity" >
                    <span
                      v-if="conversation.blocked"
                      class="mr-2" >🚫 Blocked</span>
                    <span
                      v-if="!conversation.contact.has_messaging_consent" >⛔ Unsubscribed</span>
                  </span>
                  <span
                    v-else-if="!conversation.changed_activity"
                    :class="{ hide: numberMembers && activeConversation && ((numberMembers[activeConversation.business_id] && numberMembers[activeConversation.business_id].length === 1) || (numberMembers[activeConversation.businessId] && numberMembers[activeConversation.businessId].length === 1)) }"
                    class="conversation-footer assignee-name">{{ findAssigneeName(conversation.user_id) }}</span>
                  <span
                    v-else
                    class="conversation-footer changed-activity-message">{{ conversation.changed_activity.text }}</span>
                </div>
              </div>
            </Transition>
          </div>
        </template>

        <!-- No results -->
        <div
          v-if="!forceSpinner && conversationsLoad.loaded && searchQuery && !conversations.length"
          class="no-results" >
          <p><span class="emoji-fix">😐</span> We couldn't find anything for</p>
          <b>{{ searchQuery }}</b>
        </div>
        <!-- || (noVisibleConversations && (!noConversations && !noOpenConversations)) -->
        <Spinner
          v-else-if="(!preventSpinner && (forceSpinner || !conversationsLoad.loaded)) || (!preventSpinner && conversationsLoad.loaded && !conversations.length && !noConversations && !noOpenConversations)"
          class="mt-3"
          :thickness="2" />
        <div
          v-else-if="(conversationsLoad.loaded && (page !== 1) && (page >= lastPage)) && (!noVisibleConversations)"
          class="no-more-data">No more conversations.</div>

        <!-- No Done conversations -->
        <div
          v-if="!forceSpinner && noDoneConversations && noVisibleConversations && conversationsLoad.loaded && !preventSpinner && folder === 'done' && !searchQuery"
          class="empty-conversations flex flex-column center-all" >
          <h3>No conversations</h3>
          <p>There are no {{ filtersString }} conversations{{ hasMemberInFilters ? ' for selected team member' : '' }} in {{ numberId ? '' : 'my ' }}Done folder.</p>
        </div>

        <!-- No Open conversations -->
        <div
          v-if="!forceSpinner && noOpenConversations && noVisibleConversations && conversationsLoad.loaded && !preventSpinner && folder === 'open' && !searchQuery"
          class="empty-conversations flex flex-column center-all" >
          <h3>{{ numberId ? 'I' : 'My i' }}nbox zero</h3>
          <p>There are no {{ filtersString }} conversations{{ hasMemberInFilters ? ' for selected team member' : '' }} in {{ numberId ? '' : 'my ' }}Open folder.</p>
        </div>
      </div>
    </ScrollArea>
  </div>
</template>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition-property: opacity, transform;
  transition-duration: .3s;
  transition-timing-function: ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.v-enter-to {
  animation-duration: 0.3s;
  animation-name: slidein;
}

@keyframes slidein {
  from {
    transform: translateX(-100%);
  }
  to   {
    transform: translateX(0%);
  }
}

.conversations-box {
    height: 100%;

    .scroll-area {
        max-height: 100%;

        .inbox-chat-list {
          padding: 12px 10px 12px 12px;

          .no-conversations {
            padding-top: 34px;
            font-weight: 500;
            line-height: 1.2;
            color: $blackUltralight;
            text-align: center;
          }

          .empty-conversations {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            padding: 44px 20px;
            user-select: none;

            h3 {
              font-size: 18px;
              font-weight: 500 !important;
              color: $blackPrimary;
            }

            p {
              font-size: 14px;
              font-weight: normal;
              color: $greyPrimary;
              padding-top: 8px;
              text-align: center;
              line-height: 1.4;
            }
          }
        }

        .chat-details {
            display: flex;
            align-items: flex-start;
            padding: 15px;
            border-radius: 5px;
            cursor: pointer;

            &:hover {
                background-color: $grayHover;
            }

            & > .avatar {
                width: 36px;
                margin-right: 7px;
                position: relative;

                .blocked-conversation {
                  position: absolute;
                  right: 0;
                  top: 24px;
                }
            }

            .data {
                width: calc(100% - 43px);
                position: relative;

                .title {
                  display: flex;
                  justify-content: space-between;

                  & * {
                      line-height: 1;
                  }

                  h5 {
                      font-size: 14px;
                      font-weight: 500;
                  }

                  .chat-date {
                      font-size: 12px;
                      font-weight: 400 !important;
                      opacity: 0.7;
                  }

                  &.new-conversation h5 {
                    color: $blackPrimary;
                    font-weight: 500;

                    span {
                      color: #00BFA5;
                      font-weight: 600;
                    }
                  }
                }

                .last-message {
                    font-size: 14px;
                    margin-top: 7px;
                    display: flex;

                    ::v-deep .emoji-fix {
                      font-size: 13px !important;
                    }

                    .avatar {
                      height: 14px;
                      width: 14px;
                      aspect-ratio: 1 / 1;
                      object-fit: cover;
                      border-radius: 50px;
                    }

                    .sender-icon{
                      height: 12px;
                      flex-shrink: 0;
                    }

                    span.counter {
                      max-height: 16px;
                      min-height: 10px;
                      min-width: 10px;
                      padding: 0px 5px;
                      border-radius: 20px;
                      background: $bluePrimary;
                      color: $white;
                      font-size: 11px;
                      font-weight: 500;
                      line-height: 2;
                    }

                    ::v-deep img {
                      height: 14px;
                      vertical-align: bottom;
                    }

                    > p {
                      max-width: 100%;
                    }
                }

                .conversation-footer  {
                    font-size: 12px;
                    display: block;
                    opacity: 0.7;
                    margin-top: 5px;

                    &.activity {
                      opacity: 1;
                      color: $blackUltralight;
                    }
                }
              
              .cancel-conversation {
                display: flex;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                align-items: center;
              }
            }

            &.not-seen {
              * {
                font-weight: bold !important;
              }

              &.active-chat .data {
                .last-message {
                  span.counter {
                    background: $white;
                    color: $bluePrimary
                  }
                }
              }
            }

            &.active-chat {
              background-color: $bluePrimary;
              color: #ffffff;

              .title.new-conversation h5 {
                color: $white;

                span {
                  color: #B0E9E1;
                }
              }

              .conversation-footer.activity {
                color: $white;
              }

              .data .last-message {
                span.counter {
                  background: $white;
                  color: $bluePrimary
                }
              }

              ::v-deep .avatar-placeholder {
                opacity: 0.7;
              }
            }
        }
    }

    .no-more-data {
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      color: $greyPrimary;
      padding: 10px 0;
    }

  .no-results {
    margin-top: 27px;
    text-align: center;

    p, b, span {
      font-size: 14px !important;
      line-height: 1.21 !important;
    }
  }
}

.top-10 {
  top: 10px;
}

::v-deep .v-scroll-visible {
  .inbox-chat-list {
    padding-right: 8px !important;
  }
}
</style>

<script>
import ClickOutside from 'v-click-outside';
import { mapActions, mapGetters } from 'vuex';
import NotificationSoundMixin from '@/mixins/NotificationSound';
import ScrollArea from '../../common/ScrollArea';
import MessageContent from '../../common/MessageContent';
import Spinner from '../../common/Spinner';
import SBAvatar from '../../common/Avatar';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import { getMediaType, getMediaName } from '@/helpers/mediaHelpers';
import api from '@/helpers/api';
import ToasterMixin from '@/mixins/Toaster';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import DotSeparator from '@/components/common/DotSeparator';

export default {
  name: 'ConversationsTmp',
  components: {
    ScrollArea,
    MessageContent,
    SBIcon,
    Spinner,
    SBAvatar,
    DotSeparator,
  },
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  mixins: [
    ToasterMixin,
    UserPermissionsMixin,
    NotificationSoundMixin,
  ],
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
    // defines scope of the contacts. It can be searched in all numbers, just selected number or assigned to a agent
    scope: {
      type: String,
      required: false,
      default: '',
    },
    filter: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      conversations: [],
      currentConversation: {},
      userId: localStorage.getItem('userId'),
      savedConversationId: false,
      showFolderList: false,
      showSearchForm: false,
      assignmentDot: false,
      folder: 'open',
      forceSpinner: false,
      preventSpinner: false,
      assignmentFolder: 'all',
      page: 1,
      limit: 25,
      searchExecuted: true,
      lastPage: false,
      connectionFailure: false,
      conversationListOpened: false,
      noConversations: false,
      noOpenConversations: false,
      noDoneConversations: false,
      assignmentFolderNames: {
        all: 'All',
        unassigned: 'Unassigned',
        user_assigned: 'You',
      },
      syncTempConversation: false,
      loadConversationFromRoute: null,
      showAssigned: null,
      showAll: false,
      // holds the info if the relaod should happen. Since there are a few places that initiate the reload at the same time this flag is introduced. It is being checked at the end of a cycle and reloads if necessary.
      reloadConversations: false,
      preselectFirstConversation: true,
      SBIconList,
      tempConversationsForNumber: [],
      SBColors,
      deleteTimeout: null,
      initialized: false,
      toasts: [],
      botRestartTimeout: null,
      prefetching: false,
      previousPayload: {},
      silentlyReloading: false,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      activeInbox: 'inbox/activeInbox',
      conversationList: 'chat/conversationList',
      statistics: 'chat/statistics',
      statisticLocalData: 'organisation/statisticLocalData',
      localStatsOffsetCount: 'organisation/localStatsOffsetCount',
      localStatsOffsetIds: 'organisation/localStatsOffsetIds',
      // members: 'merchant/members', // replaced by organisation getters
      membersLookup: 'organisation/currentOrganisationMembersLookup',
      conversationSeen: 'chat/conversationSeen',
      unreadConversationsCount: 'chat/unreadConversationsCount',
      newMessageConversation: 'pusher/newMessageConversation',
      newConversationActivity: 'pusher/newConversationActivity',
      conversationsLoad: 'chat/conversationsLoad',
      echoConnectionLost: 'pusher/echoConnectionLost',
      currentOrganisation: 'organisation/currentOrganisation',
      conversationActivity: 'pusher/conversationActivity',
      tempConversations: 'chat/tempConversations',
      organisationStatistics: 'organisation/statistics',
      me: 'organisation/me',
      readUpdate: 'pusher/readUpdate',
      apiError: 'chat/apiError',
      numberMembers: 'organisation/numberMembers',
      reconnectChannel: 'pusher/reconnectChannel',
      forceResync: 'organisation/forceResync',
      currentOrganisationBusinessIds: 'organisation/currentOrganisationBusinessIds',
      finalizeSplash: 'organisation/finalizeSplash',
      conversationFastReload: 'chat/conversationFastReload',
      botStateChange: 'chat/botStateChange',
      reassignedConversation: 'chat/reassignedConversation',
      updateConversation: 'chat/updateConversation',
      updateConversations: 'chat/updateConversations',
      chatFastReload: 'chat/chatFastReload',
      permissionDenied: 'user/permissionDenied',
      pusherEmojiReactionReceived: 'chat/pusherEmojiReactionReceived',
      vuexFolder: 'chat/folder',
      totalUnreadConversations: 'organisation/totalUnreadConversations',
      unreadCounter: 'chat/unreadCounter',
      contactUpdatedFull: 'contact/contactUpdatedFull',
    }),
    isPermissionDenied() {
      return this.permissionDenied.message === 'Unauthorized IP - Access Denied';
    },
    organisationId() {
      return this.$route.params.organisationId;
    },
    numberId() {
      return this.$route.params.businessId;
    },
    userHasUnreadMessages() {
      return !!this.statistics.open.all_unread || !!this.statistics.open.user_unread[this.userId];
    },
    filtersString() {
      let value = '';
      const filters = this.filter.filters ? this.filter.filters.filter(option => option !== 'per member') : [];
      // CS - join with and at the end
      if (filters.length > 1) {
        const tmpLast = filters[filters.length - 1];
        const tmpUpToLast = [...filters].splice(0, filters.length - 1);
        value = tmpUpToLast.join(', ');
        value = `${value} and ${tmpLast} `;
      } else if (filters.length === 1) {
        value = `${filters.toString()} `;
      }

      return value;
    },
    hasMemberInFilters() {
      return !!this.filter.member;
    },
    noVisibleConversations() {
      return !this.conversations || !this.conversations.filter(conversation => !conversation.hide).length;
    },
  },
  watch: {
    updateConversation() {
      this.updateSingleConversation(this.updateConversation);
    },
    activeConversation: {
      handler(newValue, oldValue) {
        const targetConversation = this.conversations.find(c => c.id === newValue.id);
        if (targetConversation) {
          targetConversation.assignment_seen = newValue.assignment_seen;
          targetConversation.seen = newValue.seen;
        }
      },
      deep: true,
      immediate: true,
    },
    activeInbox(newValue, oldValue) {
      // if (this.initialized && newValue.subInbox && oldValue.subInbox && newValue.subInbox !== oldValue.subInbox) {
      //   this.loadConversationFromRoute = null;
      // }
      if (this.currentOrganisation.id) {
        this.resetPagination();
        this.reloadConversations = true;
      }
      this.folder = this.activeInbox.subInbox;
    },
    botStateChange() {
      const targetConversation = this.conversations.find(c => c.id === this.botStateChange.conversationId);
      if (targetConversation) {
        targetConversation.bot_active = this.botStateChange.data.bot_active;
      }
    },
    contactUpdatedFull() {
      const targetConversation = this.conversations.find(c => c.contact.id === this.contactUpdatedFull.contact_id);
      if (targetConversation) {
        targetConversation.contact.name = this.contactUpdatedFull.data.name;
        targetConversation.contact.phone = this.contactUpdatedFull.data.phone;
      }
    },
    pusherEmojiReactionReceived() {
      const conversation = this.conversations.find(conversation => conversation.id === this.pusherEmojiReactionReceived.conversationId);
      this.activeConversation.last_message = this.pusherEmojiReactionReceived.notification;
      this.activeConversation.message_direction = this.pusherEmojiReactionReceived.direction;
      this.activeConversation.direction = this.pusherEmojiReactionReceived.direction;
      // this.activeConversation.modified_at = Math.floor(Date.now() / 1000);
      // this.$set(conversation, 'modified_at', Math.floor(Date.now() / 1000));
      this.$set(conversation, 'last_message', this.pusherEmojiReactionReceived.notification);
      this.$set(conversation, 'message_direction', this.pusherEmojiReactionReceived.direction);
      this.$set(conversation, 'direction', this.pusherEmojiReactionReceived.direction);

      if (this.pusherEmojiReactionReceived.sender && this.pusherEmojiReactionReceived.direction === 'outbound') {
        this.activeConversation.sender = this.pusherEmojiReactionReceived.sender.name;
        this.activeConversation.sender_icon = this.pusherEmojiReactionReceived.sender.id;
        this.$set(conversation, 'sender', this.pusherEmojiReactionReceived.sender.name);
        this.$set(conversation, 'sender_icon', this.pusherEmojiReactionReceived.sender.id);
      }

      if (this.pusherEmojiReactionReceived.revert_message && this.pusherEmojiReactionReceived.sender && this.pusherEmojiReactionReceived.direction === 'inbound') {
        let direction = 'inbound';
        if (this.pusherEmojiReactionReceived.revert_message.sender) {
          direction = 'outbound';
        }

        this.activeConversation.message_direction = direction;
        this.activeConversation.direction = direction;
        this.activeConversation.sender = this.pusherEmojiReactionReceived.revert_message.sender;
        this.activeConversation.sender_icon = this.pusherEmojiReactionReceived.revert_message.sender_icon;
        this.$set(conversation, 'sender', this.pusherEmojiReactionReceived.revert_message.sender);
        this.$set(conversation, 'sender_icon', this.pusherEmojiReactionReceived.revert_message.sender_icon);
        this.$set(conversation, 'direction', direction);
      }
    },
    currentOrganisation(newValue, oldValue) {
      // if (this.initialized && (newValue.id !== oldValue.id)) {
      if (newValue.id !== oldValue.id) {
        this.resetPagination();
        this.reloadConversations = true;
      }
    },
    $route(to, from) {
      // console.log('-----');
      // console.log(from);
      // console.log(to);
      this.noConversations = false;
      this.setShowEmptyDone(this.noConversations && this.folder === 'done');
      this.noOpenConversations = false;
      this.setShowEmptyOpen({ status: this.noOpenConversations && this.folder === 'open' });

      if (
        (['OrganisationConversation', 'OrganisationWithId'].includes(from.name) && !['OrganisationConversation', 'OrganisationWithId'].includes(to.name)) ||
        (
          !['OrganisationConversation', 'OrganisationWithId'].includes(to.name) &&
          ((!to.params.businessId && from.params.businessId && !to.params.conversationId) || (to.params.businessId && (to.params.businessId !== from.params.businessId)))
        ) ||
        (
          ['OrganisationWithId'].includes(to.name) &&
          (!to.params.businessId && from.params.businessId)
        )
      ) {
        this.resetPagination();
        this.reloadConversations = true;
      } else if (to && to.params.conversationId && to.params.selectConversation) { // starting a new conversation flow to mimick reload flow
        this.forceSpinner = true;
        const targetFolder = to.params.preselectFolder === 'DO' ? 'done' : 'open';
        this.folder = targetFolder;
        this.setFolder(this.folder);
        this.loadConversationFromRoute = this.$route.params.conversationId;

        this.fetchSingleConversation({
          businessId: this.$route.params.businessId,
          conversationId: this.loadConversationFromRoute,
        })
          .then((result) => {
            if (result.data) {
              this.setActiveConversation(result.data);
            }
          });
        this.resetPagination();
        this.setTempConversations();
        this.loadConversations();
        this.reloadConversations = false;
      } else if (this.$route.params.conversationId) {
        const targetConversation = this.conversations.find(c => c.id === this.$route.params.conversationId);
        if (targetConversation) {
          this.currentConversation = targetConversation;
        }
      }
    },
    finalizeSplash() {
      setTimeout(() => {
        if (this.toasts.length) {
          this.toasts.forEach((toast) => {
            switch (toast) {
              case 'unknownNumber':
                this.showToaster('You don\'t have a permission to access this conversation.', null, null, 'warning');
                break;
              default:
                break;
            }
          });
        }
        this.toasts = [];
      }, 1000);
    },
    forceSpinner() {
      this.setForceConversationLoadSpinner(this.forceSpinner);
    },
    reassignedConversation(payload) {
      const targetConversation = this.conversations.find(c => c.id === payload.conversationId);
      if (targetConversation) {
        targetConversation.user_id = payload.to_user_id;
      }
    },
    scope(to, from) {
      if (this.initialized) {
        this.loadConversationFromRoute = null;
      }
      if (this.scope === 'My') {
        this.showAssigned = this.userId;
        this.showAll = false;
      } else if (this.scope === 'All') {
        this.showAssigned = null;
        this.showAll = true;
      } else if (this.scope === 'Number') {
        this.showAssigned = null;
        this.showAll = false;
      }
      if (to === 'My' || (to && from)) {
        this.reloadConversations = true;
      }

      this.changeTitle();
    },
    conversationActivity() {
      if (
        (this.numberId && this.conversationActivity.business_uid !== this.numberId) // message received for number not in focus
      ) {
        return;
      }
      const permissionToViewUnassigned = this.checkPermission('list_others_assigned_conversations');
      const permissionToViewAssignedToOthers = this.checkPermission('list_unassigned_conversations');
      const targetConversation = this.conversations.find(conversation => conversation.id === this.conversationActivity.conversation_uid);
      if (targetConversation) {
        // targetConversation.user_id = this.conversationActivity.activity.to_user_id;

        switch (this.conversationActivity.activity.action) {
          case 'folder': {
            this.handleFolderActivity(this.conversationActivity.activity, targetConversation);
            break;
          }
          case 'assignment': {
            this.handleAssignmentActivity(this.conversationActivity.activity, targetConversation);
            break;
          }
          case 'Block': {
            this.handleBlockedActivity(this.conversationActivity.activity, targetConversation);
            break;
          }
          case 'Unblock': {
            this.handleUnlockedActivity(this.conversationActivity.activity, targetConversation);
            break;
          }
          case 'messaging_consent_disabled':
            if (targetConversation) {
              targetConversation.contact.has_messaging_consent = false;
            }
            break;
          default:
            break;
        }

        // this.setStatistics(payload.merchant_conversation_statistics);
      } else if (
        this.conversationActivity &&
        this.conversationActivity.activity &&
        this.conversationActivity.business_uid &&
        this.conversationActivity.conversation_uid &&
        ( // Check if it fits info my conversations or into current number
          (['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name) && this.me.id === this.conversationActivity.activity.to_user_id) ||
          (!['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name) && this.numberId && this.conversationActivity.business_uid === this.numberId)
        ) &&
        ( // it can be added if the folder is changed but also if the assignment is changed
          (
            this.conversationActivity.activity.action === 'folder' &&
            this.conversationActivity.activity.meta_data.new_folder === this.folder
          ) ||
          (
            this.conversationActivity.activity.action === 'assignment' &&
            this.conversationActivity.conversation_folder &&
            this.conversationActivity.conversation_folder.toLowerCase() === this.folder.substring(0, 2)
          )
        ) &&
        ( // check permissions as final step
          this.me.id === this.conversationActivity.activity.to_user_id ||
          (!this.conversationActivity.activity.to_user_id && permissionToViewUnassigned) ||
          (this.conversationActivity.activity.to_user_id !== this.me.id && permissionToViewAssignedToOthers)
        )
      ) {
        this.fetchSingleConversation({
          businessId: this.conversationActivity.business_uid,
          conversationId: this.conversationActivity.conversation_uid,
        })
          .then((conversation) => {
            if (this.checkFilter({ assignedUserId: conversation.data.user_id, assignmentSeen: conversation.data.assignment_seen, seen: conversation.data.seen })) {
              this.conversations.unshift(conversation.data);
              this.conversations.sort((a, b) => b.modified_at - a.modified_at);
            }
          });
      }
      this.runFilters();
    },
    conversations(newValue, oldValue) {
      this.initialized = true;
      this.noConversations = !this.searchQuery && !this.conversations.filter((conversation => !conversation.hide)).length;
      this.setShowEmptyDone(this.noConversations && this.folder === 'done');
      this.setShowEmptyOpen({ status: this.noConversations && this.folder === 'open' });
      if (!this.currentConversation && !this.initialized && this.conversationsLoad.loaded) { // Load first non hidden conversation
        setTimeout(() => {
          if (!this.noVisibleConversations && (!this.activeConversation || !this.activeConversation.id)) {
            this.currentConversation = this.conversations.find(conversation => !conversation.hide);
          }
          this.setForceConversationLoadSpinner(false);
          this.forceSpinner = true;
          this.forceSpinner = false;
        }, 1000);
      } else if (this.$lodash.isEmpty(this.conversations)) {
        switch (this.folder) {
          case 'done':
            this.noConversations = !this.searchQuery && !this.conversations.length;
            this.noDoneConversations = true;
            break;
          case 'open':
            this.noOpenConversations = !this.searchQuery && !this.conversations.length;
            break;
          default:
            break;
        }

        this.forceSpinner = false;
        this.preventSpinner = false;
        this.setForceConversationLoadSpinner(this.forceSpinner);
      }
    },
    async conversationsLoad(load) {
      if (load.loaded) {
        // this.$eventBus.$emit('close-new-conversation-bar');
        this.lastPage = this.conversationList.meta.last_page;
        this.initialized = true;
        this.forceSpinner = true;
        this.finalizeSplashView();
        this.conversations = this.$lodash.concat(this.conversations, this.conversationList.data);
        this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
        if (this.page === 1) {
          this.noDoneConversations = false;
          this.noOpenConversations = false;
          if (this.$lodash.isEmpty(this.conversations)) {
            // let hasDoneConversations = false; // We decided not to have two different messages if there is no conversations in done or there is something in done.
            switch (this.folder) {
              case 'done':
                this.noConversations = !this.searchQuery && !this.conversations.length;
                this.noDoneConversations = true;
                // this.preventSpinner = true;
                break;
              case 'open':
                // hasDoneConversations = await this.checkDone();
                this.noOpenConversations = !this.searchQuery && !this.conversations.length;
                // if (!hasDoneConversations) {
                //   this.setShowEmptyOpen({
                //     status: this.noOpenConversations,
                //     fresh: true,
                //   });
                // } else {
                //   this.setShowEmptyOpen({
                //     status: this.noOpenConversations,
                //     fresh: false,
                //   });
                // }
                break;
              default:
                break;
            }

            this.forceSpinner = false;
            this.setForceConversationLoadSpinner(this.forceSpinner);
            return;
          }
          this.setShowEmptyDone(this.noDoneConversations && this.folder === 'done');
          this.setShowEmptyOpen({ status: this.noOpenConversations && this.folder === 'open' });
          if (this.loadConversationFromRoute) {
            this.selectConversation();
          } else if (!this.savedConversationId) {
            this.currentConversation = this.$lodash.head(this.conversations);
          } else {
            this.currentConversation = this.$lodash.find(this.conversations, conversation => conversation.id === this.savedConversationId);
            if (!this.currentConversation) {
              this.currentConversation = this.$lodash.head(this.conversations);
            }
          }
          this.savedConversationId = false;
        }

        this.forceSpinner = false;

        this.$nextTick(() => {
          if (!this.$refs.conversationScrollbar.verticalScrollActive) {
            this.loadMoreConversations();
          }
        });
      }
    },
    echoConnectionLost(connectionLost) {
      if (connectionLost) {
        this.connectionFailure = true;
      } else {
        this.connectionFailure = false;
        this.savedConversationId = this.currentConversation.id;
      }
    },
    reconnectChannel() {
      // Do not trigger on initial connect
      if (this.reconnectChannel > 1) {
        this.silentReloadConversations();
      }
    },
    forceResync() {
      this.silentReloadConversations();
    },
    currentConversation(conversation) {
      this.conversations = this.$lodash.filter(this.conversations, conversation => !conversation.changed_activity);
      this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
      if (conversation) {
        this.setActiveConversation(conversation);
        this.setUrlConversation(conversation);
        this.$set(conversation, 'addedToNumberUnreadCount', false);
      } else if (this.activeConversation) {
        this.currentConversation = this.activeConversation;
      }
    },
    conversationSeen(conversationData) {
      if (conversationData && this.activeConversation.id === conversationData.conversation.id) {
        return;
      }
      if (conversationData) {
        const index = this.$lodash.findIndex(this.conversations, { id: conversationData.conversation.id });
        if (index !== -1) {
          this.conversations[index].seen = conversationData.conversation.seen;
          this.conversations[index].assignment_seen = conversationData.conversation.assignment_seen;
          if (
            (conversationData.conversation && this.currentConversation.id === conversationData.conversation.id) ||
            (this.currentConversation.id === conversationData.conversation.id)
          ) {
            this.currentConversation.seen = conversationData.conversation.seen;
          }

          const statisticPayload = {
            businessId: conversationData.business_uid,
            conversationId: this.conversations[index].id,
            unseenMessages: 0,
            myConversation: conversationData.conversation ? conversationData.conversation.assigned_user_id === this.me.id : false,
            myId: this.me.id,
            seenPayload: conversationData.conversation,
          };

          this.updateStatisticLocalData(statisticPayload);
        } else if (conversationData.business_uid) { // conversation is not on the current list and is probably on another number but we need to log it locally for counter data
          const statisticPayload = {
            businessId: conversationData.business_uid,
            conversationId: conversationData.conversation.id,
            unseenMessages: 0,
            myConversation: conversationData.conversation ? conversationData.conversation.assigned_user_id === this.me.id : false,
            myId: this.me.id,
            seenPayload: conversationData.conversation,
          };

          this.updateStatisticLocalData(statisticPayload);
        }
      }
    },
    filter() {
      this.noConversations = false;
      this.setShowEmptyDone(this.noConversations && this.folder === 'done');
      this.noOpenConversations = false;
      this.setShowEmptyOpen({ status: this.noOpenConversations && this.folder === 'open' });

      this.searchExecuted = true;
      this.resetPagination();
      this.loadConversations();
    },
    // TODO looks like this is really unneccessary. set statistics is being set in action but lets leave this here for now not to brake anything.
    // unreadConversationsCount(unreadData) {
    // if (!this.$lodash.isEmpty(unreadData)) {
    //   this.statistics.open.all_unread = unreadData.unread_conversations.all_unread;
    //   this.statistics.open.user_unread = unreadData.unread_conversations.user_unread;
    //   this.statistics.open.unassigned_unread = unreadData.unread_conversations.unassigned_unread;
    //   this.setStatistics(this.statistics);
    // }
    // },
    newMessageConversation(payload) {
      if (!this.checkFilter({ assignedUserId: payload.assigned_user_id, assignmentSeen: false, seen: false })) {
        return;
      }
      if (!payload.message.timestamp) {
        payload.message.timestamp = payload.message.sent_at ? payload.message.sent_at : (payload.message.data.timestamp ? payload.message.data.timestamp : Date.now());
      }
      // Do not add conversation to list if number in focus is not the one update is received or if view is in my chats but the assigned user is not the same as logged in user.
      if (
        (this.numberId && payload.business_uid !== this.numberId) || // message receved for number not in focus
        (['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name) && payload.assigned_user_id !== this.me.id) // message recived for a different user if in my chats section
      ) {
        // this.justProcessMessage(payload);
        return;
      }

      const conversation = this.conversations.find(conversation => conversation.id === payload.conversation_uid);
      if (!conversation && payload.message.live_inbox === false) { // live_inbox === false because it could also be missing or null which should be treated as true
        return;
      }
      if (!conversation && payload.business_uid && payload.conversation_uid) {
        // check oposite folder because at this moment we do not know in which folder the conversation is
        // TODO conversations in done are automatically moved to open whwn message is received
        const opositeFolder = this.folder === 'open' ? 'done' : 'open';
        if (
          this.conversationFastReload[payload.business_uid] &&
          this.conversationFastReload[payload.business_uid][opositeFolder] &&
          this.conversationFastReload[payload.business_uid][opositeFolder].find(c => c.id === payload.conversation_uid)
        ) {
          return;
        }

        this.fetchSingleConversation({
          businessId: payload.business_uid,
          conversationId: payload.conversation_uid,
        })
          .then((conversation) => {
            // check if it fits to the folder in focus
            if (
              (conversation.data.folder !== this.folder) ||
              !(conversation.data.contact.name.includes(this.searchQuery) || conversation.data.contact.phone.includes(this.searchQuery))
            ) {
              return;
            }
            this.conversations.unshift(conversation.data);
            // if (payload.message.direction === 'inbound') {
            // this.fetchOrganisationStatistics(this.organisationId); // NOTE: We decided not to update statistics here but it is left here in case we change something.
            // }
          });
        return;
      }
      if (payload.message.direction === 'inbound') {
        this.$set(conversation, 'inbound_sent_at', payload.message.timestamp);
        this.$set(conversation, 'modified_at', payload.message.timestamp);
        this.$set(conversation, 'last_message', payload.message.body);
        this.$set(conversation, 'last_message_media', payload.message.media_type);
        this.$set(conversation, 'message_direction', payload.message.direction);
        this.$set(conversation, 'user_id', payload.assigned_user_id);
        conversation.broadcast = payload.message.broadcast;
        conversation.direction = payload.message.direction;
        conversation.live_inbox = true;
        conversation.contact.has_messaging_consent = true;

        // this.setStatistics(payload.merchant_conversation_statistics); TODO - nemam statics odma
        if (!this.$lodash.isEmpty(this.conversations)) {
          this.conversations = this.$lodash.filter(this.conversations, conversationItem => conversationItem.id !== payload.conversation_uid);
          this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
        }

        if (this.currentConversation.id !== payload.conversation_uid) {
          this.notifySound();
          this.$set(conversation, 'seen', false);
        } else if (payload.message.direction === 'inbound') {
          if (!document.hasFocus()) {
            this.notifySound();
            this.$set(conversation, 'seen', false);
          }
        }

        if (this.currentConversation.id === payload.conversation_uid) {
          this.setCurrentConversationLastInbound(payload);
        }
      } else if (payload.message.direction === 'outbound') {
        // Add to conversation last message
        conversation.message_direction = 'outbound';
        conversation.last_message = payload.message.body;
        conversation.last_message_media = payload.message.media_type;
        conversation.message_sent_at = payload.message.timestamp;
        conversation.modified_at = payload.message.timestamp;
        conversation.broadcast = payload.message.broadcast;
        conversation.direction = payload.data ? payload.data.direction : payload.message.direction;
        conversation.sender = payload.data ? payload.data.sender : payload.message.sender;
        conversation.sender_icon = payload.data ? payload.data.sender_icon : payload.message.sender_icon;
        conversation.agent = payload.data ? payload.data.agent : payload.message.agent;
        conversation.live_inbox = payload.message.live_inbox;
        // if (payload.message.broadcast) {
        const conversationBackup = JSON.stringify(conversation);
        const conversationIndex = this.conversations.findIndex(conversation => conversation.id === payload.conversation_uid);
        if (payload.message && payload.message.live_inbox) {
          this.conversations.splice(conversationIndex, 1);
          this.conversations.unshift(JSON.parse(conversationBackup));
        }
        this.conversations = [...this.conversations];
        this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
        // }
      }
      if (payload.message.direction === 'inbound' && this.folder === 'open') {
        if (
          (this.assignmentFolder === 'all') ||
          ((this.assignmentFolder === 'unassigned') && (payload.assigned_user_id === null)) ||
          ((this.assignmentFolder === 'user_assigned') && (payload.assigned_user_id === this.userId))
        ) {
          this.conversations.unshift(conversation);
        }
        if ((this.currentConversation.id === payload.message.direction) && (payload.message.direction === 'inbound')) {
          this.currentConversation.seen = false;
        }
      } else if ((payload.message.direction === 'inbound') && (this.currentConversation.id === payload.message.direction) && (this.folder === 'done')) {
        this.conversations.unshift(conversation);
        this.addFolderChangedActivity(payload.message.direction, 'open');
      }

      if (this.activeConversation.id !== payload.conversation_uid && payload.message.direction === 'inbound') {
        conversation.message_unseen_count++;
        this.$set(conversation, 'addedToNumberUnreadCount', true);
      } else if (!document.hasFocus() && payload.message.direction === 'inbound') {
        conversation.message_unseen_count++;
        this.$set(conversation, 'addedToNumberUnreadCount', true);
      }

      if (this.activeConversation.id === payload.conversation_uid && document.hasFocus()) {
        this.$nextTick(() => {
          this.markConversationAsSeen({
            organisationId: this.currentOrganisation.id,
            merchant_id: this.activeConversation.business_id,
            conversation_id: this.activeConversation.id,
            folder: this.activeConversation.folder,
            data: {
              seen: true,
              includeMe: false,
            },
          });
        });
      }

      if (this.activeConversation.id === payload.conversation_uid) {
        this.activeConversation.inbound_sent_at = payload.message.timestamp;
        this.activeConversation.modified_at = payload.message.timestamp;
        this.activeConversation.last_message = payload.message.body;
        this.activeConversation.last_message_media = payload.message.media_type;
        this.activeConversation.message_direction = payload.message.direction;
        this.activeConversation.modified_at = payload.message.timestamp;
        this.$set(conversation, 'modified_at', payload.message.timestamp);
        this.$set(conversation, 'last_message', payload.message.body);
        this.$set(conversation, 'message_direction', payload.message.direction);
        this.$set(conversation, 'user_id', payload.assigned_user_id);
        conversation.broadcast = payload.message.broadcast;
        this.unseenActiveConversation();
      }

      if (!conversation.last_message && payload.message.media_type && !['image', 'audio', 'video'].includes(getMediaType(payload.message.media_type))) {
        this.$set(conversation, 'last_message', getMediaName(payload.message.media_url).replace(/.*fileName=/, ''));
      }

      conversation.direction = payload.data ? payload.data.direction : payload.message.direction;
      conversation.sender = payload.data ? payload.data.sender : payload.message.sender;
      conversation.sender_icon = payload.data ? payload.data.sender_icon : payload.message.sender_icon;

      this.runFilters();
    },
    numberId: {
      handler() {
        if (this.numberId) {
          this.resetOrganisationContacts();
          this.fetchOrganisationContacts({
            organisationId: this.currentOrganisation.id,
            data: {
              conversations_business: this.numberId,
              limit: 50,
              page: 1,
            },
          });
          this.$nextTick(() => {
            this.changeTitle();
          });
        }
      },
      immediate: true,
    },
    readUpdate() {
      const myConversation = this.readUpdate.conversation && this.readUpdate.conversation.assigned_user_id === this.me.id;
      // if (
      //   (myConversation && this.readUpdate.conversation && this.activeConversation.id === this.readUpdate.conversation.id && !this.readUpdate.conversation.assignment_seen) ||
      //   (!myConversation && this.readUpdate.conversation && this.activeConversation.id === this.readUpdate.conversation.id && !this.readUpdate.conversation.seen)
      // ) {
      //   return;
      // }
      const conversation = this.conversations.find(conversation => conversation.id === this.readUpdate.conversation.id);
      if (conversation) {
        conversation.seen = this.readUpdate.conversation.seen;
        conversation.assignment_seen = this.readUpdate.conversation.assignment_seen;

        let counter = this.organisationStatistics[this.readUpdate.business_uid].open.all_unread;
        let userCounter = this.organisationStatistics[this.readUpdate.business_uid].open.user_unread[this.me.id];
        if (this.readUpdate.conversation.seen && conversation.folder === 'open') {
          counter = counter > 0 ? --counter : 0;
          if (myConversation) {
            userCounter = userCounter > 0 ? --userCounter : 0;
          }
          this.$set(conversation, 'addedToNumberUnreadCount', false);
          if (!myConversation) {
            this.$nextTick(() => {
              this.decrementStatisticLocalData(
                {
                  businessId: this.readUpdate.business_uid,
                  conversationId: this.readUpdate.conversation.id,
                  myChat: this.readUpdate.conversation.assigned_user_id === this.me.id,
                },
              );
            });
          }
        } else if (!this.readUpdate.conversation.seen && conversation.folder === 'open') {
          counter++;
          // remove messages unread counter on conversation. This way if new mwssage comes the counter will start from 0 and not from where it is for the assigned user
          this.$set(conversation, 'addedToNumberUnreadCount', true);
          this.$nextTick(() => {
            this.incrementStatisticLocalData(
              {
                businessId: this.readUpdate.business_uid,
                conversationId: this.readUpdate.conversation.id,
                myChat: this.readUpdate.conversation.assigned_user_id === this.me.id,
              },
            );
          });
        } else if (this.readUpdate.conversation.seen && conversation.folder === 'done') {
          this.$nextTick(() => {
            this.decrementStatisticLocalData(
              {
                businessId: this.readUpdate.business_uid,
                conversationId: this.readUpdate.conversation.id,
                myChat: this.readUpdate.conversationassigned_user_id === this.me.id,
              },
            );
          });
        }
        if (this.readUpdate.conversation.assignment_seen) {
          this.resetUnreadCount(this.readUpdate.conversation.id);
          this.setNumberUnreadCounter({
            numberId: this.readUpdate.business_uid,
            userCounter,
            counter,
          });
        }
      } else if (!this.readUpdate.conversation.seen) {
        api('GET', `/organisation/${this.currentOrganisation.id}/business/${this.readUpdate.business_uid}/conversation/${this.readUpdate.conversation.id}`, null, null, 'w')
          .then((response) => {
            if (response.status === 200 && response.data.folder === 'open') {
              this.$nextTick(() => {
                this.incrementStatisticLocalData(
                  {
                    businessId: this.readUpdate.business_uid,
                    conversationId: this.readUpdate.conversation.id,
                    myChat: this.readUpdate.conversationassigned_user_id === this.me.id,
                  },
                );
              });
            }
          });
      } else {
        api('GET', `/organisation/${this.currentOrganisation.id}/business/${this.readUpdate.business_uid}/conversation/${this.readUpdate.conversation.id}`, null, null, 'w')
          .then((response) => {
            if (response.status === 200 && response.data.folder === 'open') {
              this.$nextTick(() => {
                this.decrementStatisticLocalData(
                  {
                    businessId: this.readUpdate.business_uid,
                    conversationId: this.readUpdate.conversation.id,
                    myChat: this.readUpdate.conversationassigned_user_id === this.me.id,
                  },
                );
              });
            }
          });
      }
    },
    folder(folder) {
      this.forceSpinner = true;
      this.noConversations = false;
      this.setShowEmptyDone(this.noConversations && this.folder === 'done');
      this.noOpenConversations = false;
      this.setShowEmptyOpen({ status: this.noOpenConversations && this.folder === 'open' });
      this.$emit('folderChanged', folder);
    },
    searchQuery() {
      this.searchConversations();
    },
    newConversationActivity(payload) {
      const activity = payload.activity;
      const activityConversation = payload.conversation;
      let targetConversation;
      switch (activity.action) {
        case 'folder': {
          this.handleFolderActivity(activity, activityConversation);
          break;
        }
        case 'assignment': {
          this.handleAssignmentActivity(activity, activityConversation);
          break;
        }
        case 'messaging_consent_disabled':
          targetConversation = this.conversations.find(conversation => conversation.id === payload.conversation_uid);
          if (targetConversation) {
            targetConversation.contact.has_messaging_consent = payload.consent;
          }
          break;
        default:
          break;
      }

      this.setStatistics(payload.merchant_conversation_statistics);
    },
    assignmentFolder(assignment) {
      this.resetPagination();
      this.$emit('assignmentFolderChanged', assignment);
      this.loadConversations();
    },
    /** Reloads conversation once after active inbox switch because both scope and active inbox cause reload to trigger. */
    reloadConversations(newValue, oldValue) {
      // if (this.initialized && this.reloadConversations && newValue !== oldValue) {
      if (!this.prefetching && this.reloadConversations && newValue !== oldValue) {
        this.resetPagination();
        this.setTempConversations();
        this.loadConversations();
        this.reloadConversations = false;
      }
    },
    tempConversations(newValue, oldValue) {
      const tempAdded = newValue.length > oldValue.length;
      this.setTempConversations(tempAdded);
    },
    updateConversations(newValue) {
      newValue.conversations.forEach((conversationId) => {
        // Check conversation is on the list and update only if it is
        const targetConversation = this.conversations.find(c => c.id === conversationId);
        if (targetConversation) {
          this.fetchSingleConversation({
            businessId: newValue.businessId,
            conversationId,
          })
            .then((conversation) => {
              targetConversation.last_message = conversation.data.last_message;
              targetConversation.last_message_media = conversation.data.media_type;
              targetConversation.modified_at = conversation.data.message_sent_at;
              targetConversation.message_direction = conversation.data.message_direction;
              targetConversation.direction = conversation.data.direction;
              targetConversation.seen = conversation.data.seen;
              targetConversation.user_id = conversation.data.user_id;
              targetConversation.broadcast = conversation.data.broadcast;
              targetConversation.sender = conversation.data.sender;
              targetConversation.sender_icon = conversation.data.sender_icon;
              targetConversation.agent = conversation.data.agent;
              targetConversation.live_inbox = conversation.data.live_inbox;

              // Check chat fast reload and clear it if the conversation is present there
              if (this.chatFastReload[conversationId]) {
                this.removeFromFastLoad({ conversationId });
              }
            });
        }
      });
    },
  },
  mounted() {
    this.finalizeSplashView();
    this.noConversations = false;
    this.setShowEmptyDone(this.noConversations && this.folder === 'done');
    this.noOpenConversations = false;
    this.setShowEmptyOpen({ status: this.noOpenConversations && this.folder === 'open' });
    this.setForceConversationLoadSpinner(true);
    this.$eventBus.$on('remove-conversation', this.removeConversation);
    this.$eventBus.$on('conform-conversation-remove', this.confirmConversationRemove);
    this.$eventBus.$on('add-conversation', this.addConversation);
    this.$eventBus.$on('template-message-sent', this.convertTempToRealConversation);
    this.$eventBus.$on('real-conversation-received', this.swapComplete);
    this.$eventBus.$on('template-message-assign', this.assignMeToConversation);
    this.$eventBus.$on('template-message-assign-failed', this.assignPreviousUserToConversation);
    this.$eventBus.$on('reset-unread-counter', this.resetUnreadCount);
    this.$eventBus.$on('unfollow-conversation', this.handleUnfollowActivity);
    this.$eventBus.$on('unassign-conversation', this.handleUnassignActivity);
    this.$eventBus.$on('emoji-reaction', (payload) => {
      const targetConversation = this.conversations.find(c => c.id === payload.conversationId);
      if (targetConversation) {
        targetConversation.last_message = payload.last_message;
        targetConversation.direction = 'outbound';
        // targetConversation.modified_at = Math.floor(Date.now() / 1000);
        targetConversation.sender = payload.sender;
        targetConversation.sender_icon = payload.sender_icon;
      }
      // Maybe just move the target conversation to the top so the ordering of the conversations without 'message_sent_at' is not messed up as it is now.
      // this.conversations = this.$lodash.orderBy(this.conversations, 'message_sent_at', 'desc'); // OLD implementation
      // No need to move the conversation up when reaction is sent.
      // this.conversations = this.$lodash.orderBy(this.conversations, [message => !!message.modified_at, 'modified_at'], ['desc', 'desc']);
    });
    this.loadConversationFromRoute = this.$route.params.conversationId;
    if (this.$route.params.search_query) {
      this.setContactSearchRouteParams();
    }

    // 1. load the route conversation
    if (this.loadConversationFromRoute) {
      this.prefetch();
    } else {
      this.folder = this.vuexFolder;
      this.resetPagination();
      this.setTempConversations();
      this.loadConversations();
      this.reloadConversations = false;
    }
    this.$eventBus.$on('newmessagesent', (payload) => {
      const targetConversation = this.conversations.find(c => c.id === payload.conversation_id);
      if (targetConversation) {
        targetConversation.last_message = payload.last_message;
        targetConversation.last_message_media = payload.media_type;
        targetConversation.message_direction = payload.message_direction;
        targetConversation.direction = 'outbound';
        targetConversation.live_inbox = true;
        targetConversation.message_sent_at = payload.message_sent_at;
        targetConversation.modified_at = payload.message_sent_at;
        delete targetConversation.broadcast;
        targetConversation.user_id = this.me.id;
        targetConversation.sender = payload.sender;
        targetConversation.sender_icon = payload.sender_icon;
        targetConversation.agent = payload.agent;
      }
      // console.log('bug - conversation should jump to the top - fix it when you will have two phones available');
      // Maybe just move the target conversation to the top so the ordering of the conversations without 'message_sent_at' is not messed up as it is now.
      // this.conversations = this.$lodash.orderBy(this.conversations, 'message_sent_at', 'desc'); // OLD implementation
      this.conversations = this.$lodash.orderBy(this.conversations, [message => !!message.modified_at, 'modified_at'], ['desc', 'desc']);
      this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
    });

    this.$eventBus.$on('contactDataChanged', (payload) => {
      const conversation = this.$lodash.find(this.conversations,
        conversation => conversation.id === payload.conversation_id);
      if (conversation) {
        conversation.contact = payload.contact;
      }
    });

    this.$eventBus.$on('change-new-temp-conversation-id', (newIdSufix) => {
      const conversation = this.conversations.find(conversation => conversation.id.startsWith('TEMP-conversation'));
      if (conversation) {
        conversation.id = `${conversation.id}-${newIdSufix}`;
        this.silentConversationUpdate(conversation);
      }
    });

    this.$eventBus.$on('sync-new-temp-conversation-id', () => {
      this.syncTempConversation = true;
    });

    // this.$eventBus.$on('remove-new-temp-conversation', () => {
    //   this.conversations = [...this.conversations.filter(conversation => !conversation.id.startsWith('TEMP-conversation'))];
    //   this.currentConversation = this.conversations.length >= 0 ? this.conversations[0] : null;
    // });

    if (this.numberId) {
      this.fetchOrganisationContacts({
        organisationId: this.currentOrganisation.id,
        data: {
          conversations_business: this.numberId,
          limit: 50,
          page: 1,
        },
      });
    }
  },
  methods: {
    ...mapActions({
      fetchConversationsForInbox: 'chat/fetchConversationsForInbox',
      setStatistics: 'chat/setStatistics', // TODO refactor this to organisation component
      // updateChatStatus: 'chat/updateStatus',
      setActiveConversation: 'chat/setActiveConversation',
      silentFetchConversationsForInbox: 'chat/silentFetchConversationsForInbox',
      finalizeSplashView: 'organisation/finalizeSplashView',
      removeNewTempConversation: 'chat/removeNewTempConversation',
      setFolder: 'chat/setFolder',
      setShowEmptyDone: 'chat/setShowEmptyDone',
      setShowEmptyOpen: 'chat/setShowEmptyOpen',
      setForceConversationLoadSpinner: 'chat/setForceConversationLoadSpinner',
      setNumberUnreadCounter: 'organisation/setNumberUnreadCounter',
      fetchOrganisationStatistics: 'organisation/fetchOrganisationStatistics',
      fetchOrganisationNumberStatistics: 'organisation/fetchOrganisationNumberStatistics',
      markConversationAsSeen: 'chat/markConversationAsSeen',
      fetchSingleConversation: 'chat/fetchSingleConversation',
      setCurrentConversationLastInbound: 'chat/setCurrentConversationLastInbound',
      fetchOrganisationContacts: 'contact/fetchOrganisationContacts',
      updateStatisticLocalData: 'organisation/updateStatisticLocalData',
      removeFromFastLoad: 'chat/removeFromFastLoad',
      incrementStatisticLocalData: 'organisation/incrementStatisticLocalData',
      decrementStatisticLocalData: 'organisation/decrementStatisticLocalData',
      fetchContactData: 'contactDetails/contactDataFetch',
      setContactDataLoading: 'contactDetails/setContactDataLoading',
      clearMessageListMeta: 'chat/clearMessageListMeta',
      editActiveConversationData: 'chat/editActiveConversationData',
      resetOrganisationContacts: 'contact/resetOrganisationContacts',
      unseenActiveConversation: 'chat/unseenActiveConversation',
      resetLocalCounter: 'organisation/resetLocalCounter',
      updateAllConversationsList: 'chat/updateAllConversationsList',
    }),
    assignMeToConversation(payload) {
      if (this.activeConversation.id === payload.conversationId) {
        this.activeConversation.user_id = this.me.id;
      }
      const targetConversation = this.conversations.find(c => c.id === payload.conversationId);
      if (targetConversation) {
        targetConversation.user_id = this.me.id;
      }
    },
    assignPreviousUserToConversation(payload) {
      if (this.activeConversation.id === payload.conversationId) {
        this.activeConversation.user_id = payload.previousUserId;
      }
      const targetConversation = this.conversations.find(c => c.id === payload.conversationId);
      if (targetConversation) {
        targetConversation.user_id = payload.previousUserId;
      }
    },
    changeFavIcon(src) {
      const favicon = document.getElementById('favicon');
      favicon.setAttribute('href', src);
    },
    changeTitle() {
      let counter = 0;
      try {
        Object.keys(this.unreadCounter).forEach((key) => {
          counter += this.unreadCounter[key].counter;
        });
      } catch (error) { /* do nothing */ }

      const countText = counter ? `(${this.$options.filters.nineNinePlus(counter)}) ` : '';
      if (this.scope === 'Number') {
        const targetNumber = this.currentOrganisation.businesses.find(b => b.id === this.numberId);
        document.title = targetNumber ? `${countText}${targetNumber.name} | AI Number` : `${countText}AI Number`;
      } else {
        document.title = `${countText}My chats | AI Number`;
      }

      // if (this.totalUnreadConversations) {
      //   this.changeFavIcon('/favicon-dot.ico');
      // } else {
      //   this.changeFavIcon('/favicon.ico');
      // }
    },
    /**
     * Checks if the conversation passes the filter set by user and only adds it to the list if it does.
     */
    checkFilter(payload) {
      const passMember = !!(!this.filter || !this.filter.member || this.filter.member.id === payload.assignedUserId);
      const passAssignment = (!this.filter || !this.filter.filters || !this.filter.filters.length || (!this.filter.filters.includes('unassigned') && !this.filter.filters.includes('assigned')) || (this.filter.filters.includes('unassigned') && !payload.assignedUserId)) || (!this.filter || !this.filter.filters || !this.filter.filters.length || (this.filter.filters.includes('assigned') && payload.assignedUserId));
      const passUnread = (!this.filter || !this.filter.filters || !this.filter.filters.length || !this.filter.filters.includes('unread') || (this.filter.filters.includes('unread') && ((payload.assignedUserId === this.me.id && !payload.assignmentSeen) || (payload.assignedUserId !== this.me.id && !payload.seen))));
      return (passMember && passAssignment && passUnread);
    },
    /**
     * Runs the filter on the conversations list and updates the list with the filtered conversations.
     */
    runFilters() {
      this.conversations = this.$lodash.filter(this.conversations, conversation => this.checkFilter({ assignedUserId: conversation.user_id, assignmentSeen: conversation.assignment_seen, seen: conversation.seen }));
      this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
    },
    prefetch() {
      this.prefetching = true;
      this.fetchSingleConversation({
        businessId: this.$route.params.businessId,
        conversationId: this.loadConversationFromRoute,
      })
        .then((result) => {
          // 2. check its folder
          if (result.data && result.data.folder) {
            // 3. set folder
            this.folder = result.data.folder;
            this.setFolder(this.folder);
            this.loadConversationFromRoute = result.data.id;
            this.setActiveConversation(result.data);
          }
        })
        .catch(() => {
          this.loadConversationFromRoute = null;
          this.showToaster('You don\'t have a permission to access this conversation.', null, null, 'warning');
        })
        .finally(() => {
          // 4. load conversations
          this.resetPagination();
          this.setTempConversations();
          this.loadConversations();
          this.reloadConversations = false;
          this.prefetching = false;

          // 5. select if on the first page - done on conversationsLoaded
        });
    },
    /**
     * Method updates local counter based on the data for the specific conversation.
     * It handles local info of all the conversation active from the page load, and if new conversation appears it first gets that conversation from backend and adds it to local list
     */
    justProcessMessage(payload) {
      if (this.statisticLocalData[payload.business_uid] && this.statisticLocalData[payload.business_uid][payload.conversation_uid] >= 0) {
        const statisticPayload = {
          businessId: payload.business_uid,
          conversationId: payload.conversation_uid,
          unseenMessages: this.statisticLocalData[payload.business_uid][payload.conversation_uid] + 1,
          myConversation: payload.conversation.assigned_user_id === this.me.id,
          myId: this.me.id,
        };

        this.updateStatisticLocalData(statisticPayload);
      } else if (payload.business_uid && payload.conversation_uid) {
        this.fetchSingleConversation({
          businessId: payload.business_uid,
          conversationId: payload.conversation_uid,
        })
          .then((conversation) => {
            if (conversation.data.message_unseen_count > 1) { // This is a special situation when we can't know if the unassigned agent has this counted already or not so we need to sync with backend
              this.fetchOrganisationNumberStatistics({
                organisationId: this.currentOrganisation.id,
                businessId: conversation.data.business_id,
                data: {
                  sections: 'all_unread,user_unread',
                },
                forceStatistics: true,
              });
            }

            const statisticPayload = {
              businessId: conversation.data.business_id,
              conversationId: payload.conversation_uid,
              unseenMessages: conversation.data.message_unseen_count,
              myConversation: conversation.data.user_id === this.me.id,
              myId: this.me.id,
            };

            this.updateStatisticLocalData(statisticPayload);
          });
      }

      // Also remove from chat fast reload to force reloading of messages
      this.removeFromFastLoad({ conversationId: payload.conversation_uid });
    },
    cancelConversation(conversation) {
      this.removeNewTempConversation(conversation);
    },
    convertTempToRealConversation(data) {
      const targetConversation = this.conversations.find(conversation => conversation.phone === data.phone);
      if (targetConversation) {
        this.setContactDataLoading();
        this.clearMessageListMeta();
        targetConversation.assignment_seen = true;
        targetConversation.blocked = false;
        targetConversation.bot_active = true;
        targetConversation.business_id = targetConversation.businessId;
        targetConversation.contact = {
          has_messaging_consent: true,
          name: '',
          phone: data.phone,
        };
        targetConversation.folder = 'open';
        targetConversation.id = targetConversation.id.replace('TEMP', 'LOAD');
        targetConversation.last_message = data.message;
        targetConversation.message_direction = data.direction;
        targetConversation.message_sent_at = data.timestamp;
        targetConversation.modified_at = data.timestamp;
        targetConversation.message_unseen_count = 0;
        targetConversation.seen = true;
        targetConversation.user_id = this.me.id;
        targetConversation.waitingForRealConversation = true;

        // Silently load first page of conversations
        const payload = {
          conversations_business: targetConversation.businessId,
          limit: 10,
          page: 1,
          search_query: data.phone,
        };

        this.setActiveConversation(targetConversation);

        // Try to get the conversation for the next 10 seconds. The conversation might not ba available right away.
        let count = 0;
        const interval = setInterval(() => {
          count++;
          api('GET', `/organisation/${this.currentOrganisation.id}/contacts`, payload, null, 'w')
            .then((response) => {
              if (response.status === 200) {
                if (response.data.data.length && response.data.data[0].conversation_id) {
                  // There is no garantie that the response will have only one conversation we need because we request it by phone and if we request 6 digit phone we can also get back the 7 digit phone namber that matches the query.
                  const matchingContact = response.data.data.find(responseConversation => responseConversation.phone === data.phone);
                  matchingContact.businessId = targetConversation.businessId;
                  matchingContact.conversationId = matchingContact.conversation_id;
                  this.getConversationAndSwap(matchingContact);
                  // Stop the interval once the required data is received
                  clearInterval(interval);
                }
              }
            })
            .catch((error) => {
              // console.log('ERROR');
            });

          if (count === 10) {
            clearInterval(interval);
          }
        }, 1000);
      }
    },
    getConversationAndSwap(contact) {
      api('GET', `/organisation/${this.currentOrganisation.id}/business/${contact.businessId}/conversation/${contact.conversation_id}`, null, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            const targetConversation = this.conversations.find(conversation => conversation.phone === contact.phone);
            targetConversation.id = response.data.id;
            this.$set(targetConversation, 'contact', response.data.contact);
            this.setActiveConversation(targetConversation);
            this.fetchContactData({
              organisation_id: this.currentOrganisation.id,
              business_id: this.activeConversation.business_id,
              contact_id: this.activeConversation.contact.id,
            });
            this.setUrlConversation(targetConversation);
            this.removeNewTempConversation(targetConversation);
          }
        })
        .catch((error) => {
          // console.log('ERROR');
        });
    },
    loadConversations(removeCurrent = true) {
      if (this.isPermissionDenied) {
        return;
      }
      if (this.numberId && !this.currentOrganisationBusinessIds.includes(this.numberId)) {
        this.toasts.push('unknownNumber');
        return;
      }
      this.noDoneConversations = false;
      this.preventSpinner = false;
      if (removeCurrent) {
        this.currentConversation = false;
      }
      let assignment;
      if (['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name) && this.userId) { // My Chats view should show only chats for a logged in user
        assignment = 'user_assigned';
      } else if (this.filter && this.filter.filters && this.filter.filters.includes('unassigned') && this.filter.filters.includes('assigned')) { // Is user selects both options then we ignore the filter and show all
        assignment = null;
      } else if (this.filter && this.filter.filters && this.filter.filters.includes('assigned')) {
        assignment = 'assigned';
      } else if (this.filter && this.filter.filters && this.filter.filters.includes('unassigned')) {
        assignment = 'unassigned';
      }
      const payload = {
        organisationId: this.currentOrganisation.id,
        businessId: this.showAll ? null : this.$route.params.businessId,
        filters: {
          page: this.page,
          limit: this.limit,
          // assigned: this.showAll || this.$route.params.businessId ? 'unassigned' : this.userId,  // DOESN'T WORK
          assignment,
          folder: this.searchQuery ? null : this.folder,
          search_query: this.searchQuery,
          unread: this.filter && this.filter.filters && this.filter.filters.includes('unread') ? true : null,
        },
      };
      if (this.filter && this.filter.member && this.filter.member.id) {
        payload.filters.assignment_user_id = this.filter.member.id;
      }

      if (!payload.businessId) {
        payload.organisationId = this.currentOrganisation.id;
      }

      if (['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name)) {
        delete payload.businessId;
      }

      // Prevents loading of the same endpoint at the same time
      if (this.$lodash.isEqual({ ...this.previousPayload, saveFirstPage: true }, { ...payload, saveFirstPage: true }) && this.conversationsLoad.loading) {
        return;
      }
      const cacheConversationTarget = payload.businessId ? payload.businessId : 'my';
      if (
        payload.organisationId &&
        payload.filters.page === 1 &&
        !payload.searchQuery &&
        !payload.filters.unread &&
        (
          (!payload.filters.assignment && payload.businessId) ||
          (payload.filters.assignment === 'user_assigned' && !payload.businessId)
        )
      ) {
        if (
          this.conversationFastReload &&
          this.conversationFastReload[cacheConversationTarget] &&
          this.conversationFastReload[cacheConversationTarget][this.folder]
        ) {
          this.conversations = [...this.conversationFastReload[cacheConversationTarget][this.folder]];
          this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
          this.$nextTick(() => {
            if (!this.activeConversation || this.activeConversation.folder !== this.folder) {
              this.currentConversation = this.conversations[0] || {};
            }
          });
          this.lastPage = 2; // we can't know in this case if there are more pages so try to get at least second one and the current paging will be updated to real value.
          this.forceSpinner = false;
          this.preventSpinner = true;
        } else {
          payload.saveFirstPage = true;
          this.fetchConversationsForInbox(payload);
        }
      } else if (payload.organisationId) {
        if (payload.page === 1) {
          payload.saveFirstPage = true;
        }
        this.fetchConversationsForInbox(payload);
      } // Otherwise let it load once the current organisation data is populated.

      this.previousPayload = payload;
    },
    /** Checking done folder to see if there was ever any conversations. */
    async checkDone() {
      this.forceSpinner = true;
      const payload = {
        organisationId: this.organisationId,
        filters: {
          businessId: this.numberId,
          limit: 1,
          folder: 'done',
        },
      };
      const request = await this.silentFetchConversationsForInbox(payload);
      return (!!request.data.data.length);
    },
    silentReloadConversations() {
      // console.log('Silent reload conversations');
      if (this.silentlyReloading) {
        return;
      }
      this.silentlyReloading = true;

      let assignment;
      if (!this.$route.params.businessId && this.userId) { // My Chats view should show only chats for a logged in user
        assignment = 'user_assigned';
      } else if (this.filter && this.filter.filters && this.filter.filters.includes('unassigned') && this.filter.filters.includes('assigned')) { // Is user selects both options then we ignore the filter and show all
        assignment = null;
      } else if (this.filter && this.filter.filters && this.filter.filters.includes('assigned')) {
        assignment = 'assigned';
      } else if (this.filter && this.filter.filters && this.filter.filters.includes('unassigned')) {
        assignment = 'unassigned';
      }
      const payload = {
        organisationId: this.currentOrganisation.id,
        businessId: this.showAll ? null : this.$route.params.businessId,
        filters: {
          page: 1,
          limit: this.limit,
          assignment,
          folder: this.searchQuery ? null : this.folder,
          businessId: this.showAll ? null : this.$route.params.businessId,
          search_query: this.searchQuery,
          unread: this.filter && this.filter.filters && this.filter.filters.includes('unread') ? true : null,
        },
      };
      if (this.filter && this.filter.member && this.filter.member.id) {
        payload.filters.assignment_user_id = this.filter.member.id;
      }

      if (['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name)) {
        delete payload.businessId;
        delete payload.filters.businessId;
      }

      const requests = [];
      let conversationsTemp = [];
      const request1stPage = this.silentFetchConversationsForInbox(payload);
      request1stPage.then((response) => {
        conversationsTemp = [...conversationsTemp, ...response.data.data];
        this.page = response.data.meta.current_page;
        this.lastPage = response.data.meta.last_page;
      });
      requests.push(request1stPage);

      Promise.all(requests)
        .then(() => {
          this.conversations = [...conversationsTemp];
          this.conversations = this.$lodash.uniqBy(this.conversations, 'id');

          if (this.$refs.conversationScrollbar) {
            this.$refs.conversationScrollbar.scrollToTop();
          }
        })
        .finally(() => {
          this.silentlyReloading = false;
        });
    },
    /** Selects conversation on the conversations list */
    selectConversation() {
      if (!this.preselectFirstConversation) {
        this.finalizeSplashView();
        return;
      }
      if (!this.conversations || !this.conversations.length) {
        this.setActiveConversation({});
      }
      const targetConversation = this.conversations.find(c => c.id === this.loadConversationFromRoute && !c.hide);
      if (targetConversation) {
        this.currentConversation = targetConversation;
        this.finalizeSplashView();
      } else if (this.number && this.number.id && this.loadConversationFromRoute) {
        // console.log('NO TARGET');
        // this.fetchSingleConversation({
        //   businessId: this.numberId,
        //   conversationId: this.loadConversationFromRoute,
        // })
        //   .then((conversation) => {
        //     if (conversation.status === 200 && conversation.data.id && (conversation.data.folder === this.folder)) {
        //       this.conversations.unshift(conversation.data);
        //       this.currentConversation = this.conversations[0];
        //       this.finalizeSplashView();
        //     } else if (this.conversations.length) {
        //       // TODO fix this when BE implements the functionality to calculate the position of the target conversation so we can load the page the target conversation is at.
        //       // We have the silentFetchConversationsForInbox action but we will probably not use it since we will be able to load a full page.
        //       // Also consider loading page before, and page after in cases the targeted conversation is first or last on the targeted page.
        //       // const endpoint = `business/${this.$route.params.businessId}/conversation/${this.$route.params.conversationId}`;
        //       // const request = api('GET', endpoint, null, null, 'w');
        //       // request.then((response) => {
        //       //   console.log('RESPONSE', response);
        //       // });
        //       this.currentConversation = this.conversations.find(conversation => !conversation.hide);
        //       this.finalizeSplashView();
        //     } else {
        //       this.finalizeSplashView();
        //     }
        //   })
        //   .catch(() => {
        //     this.currentConversation = this.conversations.find(conversation => !conversation.hide);
        //     this.finalizeSplashView();
        //   });
      }
      this.loadConversationFromRoute = null;
    },
    updateSingleConversation(data) {
      const conversationAvailable = this.conversations.find(conversation => conversation.id === data.conversationId);
      if (!conversationAvailable) return;

      this.fetchSingleConversation({
        businessId: data.numberId,
        conversationId: data.conversationId,
      })
        .then((conversation) => {
          if (this.checkFilter({ assignedUserId: conversation.data.user_id, assignmentSeen: conversation.data.assignment_seen, seen: conversation.data.seen })) {
            this.conversations.unshift(conversation.data);
            this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
            this.conversations.sort((a, b) => b.modified_at - a.modified_at);
            this.updateAllConversationsList(conversation);
          }
        });
    },
    loadMoreConversations() {
      if (this.initialized && this.conversationsLoad.loaded && (this.page < this.lastPage)) {
        this.page += 1;
        this.loadConversations(false);

        this.fetchOrganisationNumberStatistics({
          organisationId: this.currentOrganisation.id,
          businessId: this.numberId,
          data: {
            sections: 'all_unread,user_unread',
          },
        });
      }
    },
    searchConversations() {
      this.searchExecuted = true;
      this.resetPagination();
      this.assignmentFolder = 'all';
      this.loadConversations();
      this.setActiveConversation(null);
    },
    setContactSearchRouteParams() {
      this.searchQuery = this.$route.params.search_query;
      this.folder = this.$route.params.folder;
      this.showSearchForm = true;
    },
    changeCurrentConversation(conversation) {
      // this.setActiveConversation(conversation);
      this.currentConversation = conversation;
      this.conversationListOpened = false;
      this.setUrlConversation(conversation);
      this.setBotRestartCountdown();
    },
    setBotRestartCountdown() {
      // TODO
    },
    setUrlConversation(conversation) {
      if ((!conversation || (!conversation.business_id && !conversation.id)) && this.$route.params.organisationId) {
        // Uncommenting this code will not just change the url but it will try to preload first open conversation, and if we are not in the open folder it will cause an error. Leave it like this for now but plan to improve it on rewrite.
        // this.$router.push({
        //   name: 'OrganisationWithId',
        //   params: {
        //     organisationId: this.$route.params.organisationId,
        //   },
        // }).catch(() => {});
      } else if (['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name)) {
        this.$router.push({
          name: 'OrganisationConversation',
          params: {
            organisationId: this.$route.params.organisationId,
            businessId: conversation.business_id,
            conversationId: conversation.id,
          },
        }).catch(() => {});
      } else if (this.$route.params.businessId) {
        if (!conversation || !conversation.id) {
          this.$router.push({
            name: 'OrganisationBusiness',
            params: {
              organisationId: this.$route.params.organisationId,
              businessId: this.$route.params.businessId,
            },
          }).catch(() => {});
        } else {
          this.$router.push({
            name: 'OrganisationBusinessConversation',
            params: {
              organisationId: this.$route.params.organisationId,
              businessId: this.$route.params.businessId,
              conversationId: conversation.id,
            },
          }).catch(() => {});
        }
      } else if (!conversation || !conversation.id) {
        this.$router.push({
          name: 'OrganisationWithId',
          params: {
            organisationId: this.$route.params.organisationId,
          },
        }).catch(() => {});
      }
    },
    handleBlockedActivity(activity, activityConversation) {
      const blocker = this.membersLookup[activity.from_user_id].name;
      // activityConversation.last_message = `${blocker} blocked this contact`;
      // activityConversation.message_direction = 'activity';
      activityConversation.blocked = true;
    },
    handleUnlockedActivity(activity, activityConversation) {
      activityConversation.blocked = false;
    },
    handleAssignmentActivity(activity, activityConversation) {
      // If user lost the permission to see the conversation then remove it
      if (
        (['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name) && this.me.id !== activity.to_user_id) ||
        (
          this.me.id !== activity.to_user_id &&
          (
            (
              !activity.to_user_id &&
              !this.$hasPermissionInOrganisation('list_unassigned_conversations')
            ) &&
            (
              activity.to_user_id &&
              !this.$hasPermissionInOrganisation('list_others_assigned_conversations')
            )
          )
        )
      ) {
        let selectNew = false;
        const index = this.conversations.findIndex(c => c.id === activityConversation.id);
        if (activityConversation.id === this.activeConversation.id) {
          selectNew = true;
        }
        this.conversations = this.conversations.filter(conversation => conversation.id !== activityConversation.id);
        this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
        if (selectNew) {
          this.$nextTick(() => {
            if (index < this.conversations.length) {
              this.changeCurrentConversation(this.conversations[index]);
            } else if (this.conversations.length) {
              this.changeCurrentConversation(this.conversations[this.conversations.length - 1]);
            } else {
              this.changeCurrentConversation(null);
            }
          });
        }
        return;
      }

      if (!this.conversations.length && (
        ((this.assignmentFolder === 'unassigned') && !activity.to_user_id) ||
        ((this.assignmentFolder === 'user_assigned') && activity.to_user_id === this.userId)
      )) {
        this.conversations.unshift(activityConversation);
        this.currentConversation = activityConversation;
        return;
      }

      activityConversation.user_id = activity.to_user_id;

      if (((activity.to_user_id === this.userId) &&
          (this.currentConversation.id !== activityConversation.id)) || (document.hidden)) {
        this.notifySound();
      }

      const index = this.$lodash.findIndex(this.conversations, { id: activityConversation.id });
      if (index === -1) {
        if (
          ((this.assignmentFolder === 'unassigned') && !activity.to_user_id) ||
          ((this.assignmentFolder === 'user_assigned') && activity.to_user_id === this.userId)
        ) {
          this.conversations.unshift(activityConversation);
        }

        return;
      }

      this.conversations[index].user_id = activityConversation.user_id;
      if (activity.to_user_id !== this.userId) {
        this.conversations[index].assignment_seen = false;
      }
      // const toUser = activity.to_user_id ? this.$lodash.find(this.members, { id: activity.to_user_id }) : null;
      const toUser = activity.to_user_id ? this.membersLookup[activity.to_user_id] : null;
      const activityText = toUser ? `Assigned to ${(this.userId === toUser.id) ? 'you' : toUser.name}` : 'Unassigned';

      // Remove conversation if user doesn't have permission to see it
      // Note: My Chats unassignment is handled by handleUnassignActivity via event bus
      if (
        this.me.id !== activity.to_user_id &&
        !['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name) &&
        (
          (
            !activity.to_user_id &&
            !this.$hasPermissionInOrganisation('list_unassigned_conversations')
          ) ||
          (
            activity.to_user_id &&
            !this.$hasPermissionInOrganisation('list_others_assigned_conversations')
          )
        )
      ) {
        this.conversations = this.conversations.filter(conversation => conversation.id !== activityConversation.id);
        this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
      }
      if (this.currentConversation.id !== activityConversation.id) {
        activityConversation.assignment_seen = false;
      }

      if (this.currentConversation.id === activityConversation.id) {
        if (
          ((this.assignmentFolder === 'unassigned') && activity.to_user_id) ||
          ((this.assignmentFolder === 'user_assigned') && (activity.to_user_id !== this.userId))
        ) {
          this.currentConversation.changed_activity = {
            type: 'assignment',
            text: activityText,
          };
          this.$set(this.conversations, index, this.currentConversation);
        } else {
          this.$lodash.unset(this.currentConversation, 'changed_activity');
        }
      } else if (
        ((this.assignmentFolder === 'unassigned') && activity.to_user_id) ||
        ((this.assignmentFolder === 'user_assigned') && (activity.to_user_id !== this.userId))
      ) {
        this.conversations = this.$lodash.filter(this.conversations, conversation => conversation.id !== activityConversation.id);
        this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
      } else if (
        ((this.assignmentFolder === 'unassigned') && !activity.to_user_id) ||
        ((this.assignmentFolder === 'user_assigned') && activity.to_user_id === this.userId)
      ) {
        this.conversations.unshift(activityConversation);
      }
    },
    handleUnfollowActivity(conversationId) {
      const targetConversation = this.conversations.find(c => c.id === conversationId);
      if (!targetConversation) {
        return;
      }

      const index = this.conversations.findIndex(c => c.id === conversationId);

      // If it's the current conversation, mark it for removal
      if (this.currentConversation && this.currentConversation.id === conversationId) {
        this.currentConversation.changed_activity = {
          type: 'follow',
          text: 'Unfollowed',
        };
        this.$set(this.conversations, index, this.currentConversation);
      } else {
        // If it's not the current conversation, remove it immediately
        this.conversations = this.conversations.filter(conversation => conversation.id !== conversationId);
        this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
      }
    },
    handleUnassignActivity(conversationId) {
      if (!this.conversations || !Array.isArray(this.conversations) || !this.$lodash) {
        return;
      }

      const targetConversation = this.conversations.find(c => c.id === conversationId);
      if (!targetConversation) {
        return;
      }

      const index = this.conversations.findIndex(c => c.id === conversationId);

      // If it's the current conversation, mark it for removal
      if (this.currentConversation && this.currentConversation.id === conversationId) {
        this.currentConversation.changed_activity = {
          type: 'assignment',
          text: 'Unassigned',
        };
        if (this.$set) {
          this.$set(this.conversations, index, this.currentConversation);
        }
      } else {
        // If it's not the current conversation, remove it immediately
        this.conversations = this.conversations.filter(conversation => conversation.id !== conversationId);
        this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
      }
    },
    findAssigneeName(userId) {
      if (!userId) {
        return 'Unassigned';
      }

      const user = this.membersLookup[userId];
      return user ? user.name : 'Unassigned';
    },
    handleFolderActivity(activity, activityConversation) {
      if (activity.meta_data.new_folder !== this.folder) {
        this.addFolderChangedActivity(activity.conversation_id, activity.meta_data.new_folder);
      } else {
        const conversationExists = this.$lodash.find(this.conversations, { id: activityConversation.id });
        if (conversationExists) {
          this.$lodash.unset(this.currentConversation, 'changed_activity');
          this.$emit('folderActivityChanged');
        } else {
          this.conversations.unshift(activityConversation);
        }
      }
    },
    addFolderChangedActivity(conversationId, folder) {
      if (this.currentConversation.id === conversationId) {
        const index = this.$lodash.findIndex(this.conversations, { id: conversationId });
        const newFolder = folder.replace(/\b\w/g, l => l.toUpperCase());
        this.currentConversation.changed_activity = {
          type: 'folder_changed',
          text: `Moved to ${newFolder}`,
        };
        this.$set(this.conversations, index, this.currentConversation);
        this.$emit('folderActivityChanged');
      } else {
        this.conversations = this.$lodash.filter(this.conversations, conversation => conversation.id !== conversationId);
        this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
      }
    },
    conversationIsUnread(conversation) {
      return !conversation.seen || (!conversation.assignment_seen && (conversation.user_id === this.userId));
    },
    resetPagination() {
      this.conversations = [];
      this.page = 1;
      this.lastPage = 1;
    },
    showSearch() {
      this.showFolderList = false;
      this.showSearchForm = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    hideSearch() {
      if ((this.searchQuery === '') && this.searchExecuted) {
        this.showSearchForm = false;
        return;
      }

      this.resetPagination();
      this.assignmentFolder = 'all';
      this.searchQuery = '';
      this.showSearchForm = false;
      this.reloadConversations = true;
    },
    toggleFolderList() {
      this.showFolderList = !this.showFolderList;
    },
    selectMessageFolder(folder) {
      this.showFolderList = false;
      this.folder = folder;
      this.assignmentFolder = 'all';
      this.setFolder(folder);
      this.resetPagination();
      this.loadConversations();
    },
    changeAssignmentFolder(assignment) {
      this.showFolderList = false;
      this.assignmentFolder = assignment;
    },
    hideConversationList() {
      this.conversationListOpened = false;
    },
    toggleConversationList() {
      this.conversationListOpened = !this.conversationListOpened;
    },
    handleBottomScroll() {
      this.loadMoreConversations();
    },
    newestDate(conversation) {
      // let newerDate = conversation.inbound_sent_at;
      // if (this.$moment(false, false).unix(conversation.inbound_sent_at) < this.$moment(false, false).unix(conversation.message_sent_at)) {
      //   newerDate = conversation.message_sent_at;
      // }
      return conversation.modified_at;
    },
    /**
     * Requests new conversations list with number of the temp conversation as a filter to get the temp conversation details now that it has been created on the BE.
     * It then updates the data for the temp conversation.
     */
    silentConversationUpdate(conversation) {
      const payload = {
        organisationId: this.currentOrganisation.id,
        filters: {
          businessId: conversation.businessId,
          limit: 100,
          folder: 'open',
          search_query: conversation.phone,
        },
      };
      // Fetch once the template message is sent
      const interval = setInterval(() => {
        if (this.syncTempConversation) {
          this.silentFetchConversationsForInbox(payload)
            .then((response) => {
              const targetConversationFromResponse = response.data.data.find(c => c.business_id === conversation.businessId);
              if (targetConversationFromResponse) {
                const targetConversationIndex = this.conversations.findIndex(c => c.businessId === targetConversationFromResponse.business_id && c.phone === targetConversationFromResponse.contact.phone);
                if (targetConversationIndex >= 0) {
                  this.conversations[targetConversationIndex] = Object.assign(targetConversationFromResponse);

                  // TODO this causes blink effect if some other conversation is selected after sending the template
                  this.conversations = [...this.conversations];
                  this.conversations = this.$lodash.uniqBy(this.conversations, 'id');

                  if (this.activeConversation && this.activeConversation.businessId && this.conversations.length) {
                    this.currentConversation = this.conversations[0];
                  }
                }
              }
            });
          this.syncTempConversation = false;
          clearInterval(interval);
        }
      }, 100);
    },
    setTempConversations(tempAdded = false) {
      // Do not show temp conversations in done folder
      if (this.folder !== 'open') {
        // return;
      }

      const tempConversations = this.tempConversations.filter(tempConversation => (this.numberId && tempConversation.businessId === this.numberId)).reverse();
      this.tempConversationsForNumber = [];
      tempConversations.forEach((tempConversation) => {
        const serialized = JSON.stringify(tempConversation);
        this.tempConversationsForNumber.push(JSON.parse(serialized));
      });
      this.prependTempConversations();
      if (tempAdded) {
        this.changeCurrentConversation(this.conversations[0]);
      } else {
        const selectedConversation = this.conversations.find(c => c.id === this.currentConversation.id);
        if (!selectedConversation && this.conversations.length) {
          this.changeCurrentConversation(this.conversations[0]);
        }
      }
    },
    prependTempConversations() {
      const noTempConversations = this.conversations.filter(conversation => !conversation.id.startsWith('TEMP-conversation'));
      this.conversations = [...this.tempConversationsForNumber, ...noTempConversations];
      this.conversations = this.$lodash.uniqBy(this.conversations, 'id');
    },
    addConversation(conversationId) {
      setTimeout(() => { // Allow minimum time for the animation to finish before you remove the conversation.
        const targetConversationIndex = this.conversations.findIndex(conversation => conversation.id === conversationId);
        if (this.conversations[targetConversationIndex]) {
          this.$set(this.conversations[targetConversationIndex], 'hide', false);
        }
      }, 300);
    },
    removeConversation(conversationId) {
      const targetNonHiddenConversationsIndex = this.conversations.filter(conversation => !conversation.hide).findIndex(conversation => conversation.id === conversationId);
      if (targetNonHiddenConversationsIndex < 0) {
        return;
      }
      const targetConversation = this.conversations.find(conversation => conversation.id === conversationId);
      this.$set(targetConversation, 'ignore', true);
      this.$set(targetConversation, 'hide', true);

      this.noConversations = !this.searchQuery && !this.conversations.filter((conversation => !conversation.hide)).length;
      this.noOpenConversations = this.noConversations;
      this.noDoneConversations = this.noConversations;
      this.setShowEmptyDone(this.noConversations && this.folder === 'done');
      this.setShowEmptyOpen({ status: this.noConversations && this.folder === 'open' });

      const targetConversationIndex = this.conversations.findIndex(conversation => conversation.id === conversationId);
      const nextConversation = this.conversations.find((conversation, index) => index > targetConversationIndex && !conversation.hide);
      if (nextConversation) {
        setTimeout(() => {
          this.changeCurrentConversation(nextConversation);
        }, 300);
      } else {
        const prevConversation = this.conversations.slice().reverse().find((conversation, index) => index > (this.conversations.length - targetConversationIndex - 1) && !conversation.hide);
        if (prevConversation) {
          setTimeout(() => {
            this.changeCurrentConversation(prevConversation);
          }, 300);
        } else {
          this.preventSpinner = true; // Prevent the load spinner to show before the remove animation is finished
          this.$nextTick(() => {
            setTimeout(() => {
              this.preventSpinner = false;
            }, 400); // A prevent spinner timeout has to be a bit longer than the animation
          });
          // this.setActiveConversation({});
          this.currentConversation = {};
          this.conversationListOpened = false;

          this.preselectFirstConversation = false;
          // this.$router.push({
          //   name: 'OrganisationBusiness',
          //   params: {
          //     organisationId: this.$route.params.organisationId,
          //     businessId: this.$route.params.businessId,
          //   },
          // }).catch(() => {});
          // this.$nextTick(() => {
          //   this.preselectFirstConversation = true;
          // });
        }
      }
    },
    confirmConversationRemove(conversationId) {
      clearTimeout(this.deleteTimeout);
      this.deleteTimeout = setTimeout(() => { // Allow minimum time for all the hide actions to finish first and then remove conversations in bulk. Otherwise there is an issue with syncing which conversation is deleted and which isn't.
        // const targetConversationIndex = this.conversations.findIndex(conversation => conversation.id === conversationId);
        this.conversations = [...this.conversations.filter(conversation => !conversation.hide)];
      }, 2000);
    },
    // TODO - create mixin with this function since we use it also in messageList component, also do this in conversation component so this can become computed function and be more generic
    showTheUnseenMarker(conversation) {
      return (
        (conversation.message_unseen_count && !conversation.seen) ||
        (conversation.message_unseen_count && !conversation.assignment_seen && conversation.user_id === this.me.id)
      );
    },
    resetUnreadCount(targetConversationId) {
      const targetConversation = this.conversations.find(conversation => conversation.id === targetConversationId);
      if (targetConversation) {
        targetConversation.message_unseen_count = 0;
      }
    },
    swapComplete(targetConversationid) {
      const targetConversation = this.conversations.find(conversation => conversation.id === targetConversationid);
      if (targetConversation && targetConversation.waitingForRealConversation) {
        delete targetConversation.waitingForRealConversation;
        // mark assignment as seen since this is the user that initiated the conversation
        this.markConversationAsSeen({
          organisationId: this.currentOrganisation.id,
          merchant_id: targetConversation.business_id,
          conversation_id: targetConversation.id,
          folder: targetConversation.folder,
          data: {
            seen: true,
            includeMe: false,
          },
        });
      }
    },
    getMemberAvatar(conversation) {
      const member = Object.values(this.membersLookup).find(member => member.platform_id === conversation.sender_icon);
      if (member) {
        return member;
      }
      return {
        avatar: '',
      };
    },
  },
};
</script>
